import React from "react";
import { Button, Grid, IconButton } from "@material-ui/core";
import { useDispatch } from "react-redux";

import { showDialog } from "../../../../Redux/actions/dialogActions";
import DataTable from "../../../../Components/Tables/DataTables";
import ActionButtons from "../../../../Components/UI/Buttons/ActionButtons";
import AddButton from "../../../../Components/UI/Buttons/AddButton";
import AddCategory from "./AddCategory"

const VideosCategories = () => {
    const dispatch = useDispatch();
    const HeaderData = [
        { field: "title", title: "عنوان" },
        { field: "action", title: "حذف" },
    ];

    const Data = [
        {
            title: "بازو",
        },
        {
            title: "ران",
        },
        {
            title: "شکم",
        },
    ];
    const editModal = () => {};
    const showAddModal = () => {
        dispatch(showDialog(<AddCategory />, false, 'sm'));
    };
    return (
        <Grid container>
            <Grid item xs={12}>
                <AddButton title="اضافه کردن دسته بندی جدید" onClick={showAddModal} />
            </Grid>
            <Grid item xs={12}>
                <DataTable
                    title="لیست دسته بندی ویدیو ها"
                    headData={HeaderData}
                    data={Data}
                    action={(item) => (
                        <ActionButtons
                            functions={{
                                edit: () => editModal(item),
                            }}
                            remove
                        />
                    )}
                    // changeLimit={(limit) => setLimit(limit)}
                    // limit={limit}
                    // lastPage={lastPage}
                    // changePage={(page) => setPage(page)}
                />
            </Grid>
        </Grid>
    );
};

export default VideosCategories;

